import React, { FC, memo, useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { DeletableImg } from 'src/components';
import { isEqual } from 'lodash';
import { Image } from 'src/redux/slices/pc-bundles/types';

interface Props {
  images: Image[];
  isDragDisable?: boolean;
  onDeleteImg: (index: number) => void;
  onChangeImageOrder: (newImages: Image[]) => void;
}

const component: FC<Props> = ({
  images,
  isDragDisable = false,
  onDeleteImg,
  onChangeImageOrder
}) => {
  const [imageList, setImageList] = useState<Image[]>(images);

  const onDragEnd = (result: any) => {
    if (!result.destination) return;

    const reordered = Array.from(imageList);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);

    setImageList(reordered);

    if (!isEqual(imageList, reordered)) {
      onChangeImageOrder(reordered);
    }
  };

  useEffect(() => {
    setImageList(images);
  }, [images]);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={{
              display: 'flex',
              padding: '1rem',
              marginBottom: '1rem',
              overflow: 'auto'
            }}
          >
            {imageList.map((item, index) => (
              <Draggable
                key={index}
                draggableId={index.toString()}
                index={index}
                isDragDisabled={isDragDisable}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                      ...provided.draggableProps.style,
                      margin: '0 4px'
                    }}
                  >
                    <DeletableImg
                      index={index}
                      imgSrc={item.file}
                      onDelete={() => onDeleteImg(index)}
                      height={120}
                      width={120}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export const DraggableBundleImageList = memo(component);
